(function() {
  function markTransitionImage(image) {
    if (!image || image.dataset.transitionObserved === 'true') {
      return;
    }

    image.dataset.transitionObserved = 'true';

    function markLoaded() {
      image.classList.add('lazyloaded');
    }

    if (image.complete && image.naturalWidth > 0) {
      markLoaded();
      return;
    }

    image.addEventListener('load', markLoaded, { once: true });
  }

  function scanTransitionImages(root) {
    if (!root) {
      return;
    }

    if (root.matches && root.matches('img[class*="transition--"]')) {
      markTransitionImage(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll('img[class*="transition--"]').forEach(markTransitionImage);
    }
  }

  function initTransitionImages() {
    scanTransitionImages(document);

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(scanTransitionImages);
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTransitionImages, { once: true });
  } else {
    initTransitionImages();
  }
})();
